import Indicator from '../Indicator';
import LineMarker from '../markers/LineMarker';

/** P/E Ratio indicator */
export default class PERatioIndicator extends Indicator {
	/**
	 * Returns the default params for this type of indicator. Overrides abstract
	 * method inherited from Indicator.
	 * @returns {object} - Default parameters object
	 * @property {string} id - Indicator ID
	 * @property {string} name - Indicator name
	 * @property {string} description - Indicator description
	 */
	_getDefaultParams() {
		return {
			id: 'peratio',
			name: 'P/E Ratio',
			description: 'P/E Ratio plots the change in the P/E Ratio over the period of the chart.',
			componentSeries: [
				{ id: 'peratio' }
			]
		};
	}

	/**
	 * @return {object}
	 * @property {LineMarker} line
	 * @property {LineMarker} lineLow
	 */
	_getMarkers() {
		return {
			line: new LineMarker(),
			lineLow: new LineMarker()
		};
	}

	/** @param {object} data Symbol data object */
	render(data, sessionType) {
		this._renderLineMarker({
			data: data[this.params.id],
			sessionType
		});
	}
}
